/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mascot_Chat_Ph_ComposerInputs */

const tr_mascot_chat_ph_composer = /** @type {(inputs: Mascot_Chat_Ph_ComposerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir soru yaz…`)
};

const en_mascot_chat_ph_composer = /** @type {(inputs: Mascot_Chat_Ph_ComposerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask a question…`)
};

const de_mascot_chat_ph_composer = /** @type {(inputs: Mascot_Chat_Ph_ComposerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schreib eine Frage…`)
};

const ru_mascot_chat_ph_composer = /** @type {(inputs: Mascot_Chat_Ph_ComposerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Задайте вопрос…`)
};

/**
* | output |
* | --- |
* | "Ask a question…" |
*
* @param {Mascot_Chat_Ph_ComposerInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mascot_chat_ph_composer = /** @type {((inputs?: Mascot_Chat_Ph_ComposerInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mascot_Chat_Ph_ComposerInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mascot_chat_ph_composer(inputs)
	if (locale === "de") return de_mascot_chat_ph_composer(inputs)
	if (locale === "ru") return ru_mascot_chat_ph_composer(inputs)
	return tr_mascot_chat_ph_composer(inputs)
});